import React from 'react';
import {
    AutocompleteInput,
    Button,
    Datagrid,
    DateField,
    DateInput,
    Filter,
    List,
    ReferenceField,
    ReferenceInput,
    ShowButton,
    TextField
} from 'react-admin';
import Swal from "sweetalert2";
import axiosInstance from "../../api/axios";
import env from "../../env";
import {showErrorNotify, showSuccessNotify} from "../../components";
import {
    AuthorizeCancelRequestStatusInput,
    CancelRequestStatusField
} from "../PurchaseCancelRequest/CancelRequestStatus";

const canSubmit = (status) => ["DRAFT"].includes((status || "").toUpperCase());
const canEdit = (status) => ["DRAFT"].includes((status || "").toUpperCase());
const canDelete = (status) => ["DRAFT"].includes((status || "").toUpperCase());

const AcceptButton = ({record, refresh}) => {
    if (!record) return null;
    if (!canSubmit(record.status)) return null;

    const confirmSendReview = () => {
        Swal.fire({
            title: "Bạn chắc chắn muốn gửi duyệt?",
            text: "",
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        })
            .then((result) => {
                if (result.value) {
                    axiosInstance.put(`/api/purchaseCancelRequests/send-review/${record.id}`, {}, {
                        newBaseUrl: env.kiotUrl,
                    }).then((res) => {
                        if (res?.data?.success) {
                            showSuccessNotify("Gửi duyệt thành công")
                            refresh();
                        } else {
                            showErrorNotify("Gửi duyệt không thành công")
                        }
                    })
                        .catch(err => {
                            showErrorNotify(err.message)
                        })
                }
            });
    }
    return (
        <Button
            label={'Chấp nhận'}
            onClick={confirmSendReview}
        >
        </Button>
    );
};

const RejectButton = ({record, refresh}) => {
    if (!record) return null;
    if (!canSubmit(record.status)) return null;

    const confirmSendReview = () => {
        Swal.fire({
            title: "Bạn chắc chắn muốn gửi duyệt?",
            text: "",
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        })
            .then((result) => {
                if (result.value) {
                    axiosInstance.put(`/api/purchaseCancelRequests/send-review/${record.id}`, {}, {
                        newBaseUrl: env.kiotUrl,
                    }).then((res) => {
                        if (res?.data?.success) {
                            showSuccessNotify("Gửi duyệt thành công")
                            refresh();
                        } else {
                            showErrorNotify("Gửi duyệt không thành công")
                        }
                    })
                        .catch(err => {
                            showErrorNotify(err.message)
                        })
                }
            });
    }
    return (
        <Button
            label={'Chấp nhận'}
            onClick={confirmSendReview}
        >
        </Button>
    );
};
const RowActions = ({record, basePath, ...props}) => (
    <div style={{display: "flex", gap: 8}}>
        <ShowButton {...props} basePath={basePath} record={record}/>
    </div>
);
const PurchaseCancelRequestAuthorizeFilter = (props) => (
    <Filter {...props}>
        <DateInput source="fromDate" alwaysOn/>
        <DateInput source="toDate" alwaysOn/>
        <ReferenceInput source={"userId"} reference="users" alwaysOn allowEmpty>
            <AutocompleteInput optionText={"userName"}/>
        </ReferenceInput>
        <AuthorizeCancelRequestStatusInput source="status" alwaysOn/>
    </Filter>
);
export const PurchaseCancelRequestAuthorizeList = props => (
    <List filters={<PurchaseCancelRequestAuthorizeFilter/>} {...props} perPage={25} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="cancelFromDate"/>
            <TextField source="cancelToDate"/>
            <ReferenceField source="kiotConfigId" reference="kiotConfigs">
                <TextField source="name"/>
            </ReferenceField>
            <DateField source="requestTime" showTime/>
            <DateField source="authorizedTime" showTime/>
            <CancelRequestStatusField source="status"/>
            <RowActions/>
        </Datagrid>
    </List>
);

export default PurchaseCancelRequestAuthorizeList
